module.exports = __webpack_public_path__ + "img/icons B_36.c0e46076.svg";